export default __webpack_public_path__ + "static/media/Briefcase_News_Consumer_Terms_and_Conditions_updated_21_May_2018.674f068c.pdf";